import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

/**
 * Theme-consistent date picker. Drop-in replacement for the native
 * <input type="date"> DateField: string value in (YYYY-MM-DD), string out.
 *
 * Why: the native input's calendar popup is drawn by the browser/OS and
 * follows the OS accent color (red on some machines) — it cannot be themed
 * with CSS. The MUI DatePicker popup follows the app theme (purple).
 */
const ThemedDateField = ({
  value,
  onChange,
  disabled = false,
  fullWidth = false,
  minDate,
}: {
  value: string | null;
  onChange: (date: string) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  minDate?: string;
}) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      value={value ? dayjs(value) : null}
      onChange={(newValue: Dayjs | null) =>
        onChange(newValue && newValue.isValid() ? newValue.format('YYYY-MM-DD') : '')
      }
      inputFormat="DD/MM/YYYY"
      disabled={disabled}
      minDate={minDate ? dayjs(minDate) : undefined}
      renderInput={(params) => (
        <TextField {...params} fullWidth={fullWidth} variant="outlined" />
      )}
    />
  </LocalizationProvider>
);

export default ThemedDateField;
